import React from "react";
import "../CSS/ViewFuelRoyaltySubmittedData.css";
import ErrorPopup from "../../../components/element/ErrorPopup";
import Loader from "../../../components/element/Loader";
import NoDataPlaceholder from "../../../components/element/NoDataPlaceholder";
import { DATE_FORMAT } from "../../../utils/constants";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { formatToTwoDecimal } from "../../../utils/utils";

dayjs.extend(utc);

const ViewFuelRoyaltySubmittedTable = ({ fuelReading, isLoading, error }) => {
  if (error) {
    if (error.status === 404) {
      return <NoDataPlaceholder />;
    } else {
      return <ErrorPopup children={error.message}></ErrorPopup>;
    }
  }

  if (isLoading) {
    return <Loader />;
  }

  if (fuelReading && fuelReading.length === 0) {
    return <NoDataPlaceholder />;
  }

  return (
    <div className="view-fuel-royalty-submitted-data-table-parent-container">
      <div className="view-fuel-royalty-submitted-data-table-container">
        <table className="view-fuel-royalty-submitted-data-table">
          <thead>
            <tr>
              <th>No.</th>
              <th>ABO Name</th>
              <th>Submission Date</th>
              <th>Meter ID</th>
              <th>Fuel Meter Start</th>
              <th>Fuel Meter End</th>
              <th>Total Gallons of Fuel Sold</th>
              <th>Total Gallons of Fuel Waste</th>
              <th>Total Gallons of Fuel Recirculation</th>
              <th>Total Gallons of Fuel Testing</th>
              <th>Price Per Gallon</th>
              <th>VAT (10%)</th>
              <th>Total Fees (BSD)</th>
            </tr>
          </thead>
          <tbody>
            {fuelReading?.map((item, index) => (
              <React.Fragment key={index}>
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item?.fboName}</td>
                  <td>{`${dayjs(item?.submittedAt)
                    .utc()
                    .format(DATE_FORMAT)}`}</td>
                  <td>{item?.meterId}</td>
                  <td>{item?.startReading}</td>
                  <td>{item?.endReading}</td>
                  <td>{item?.totalFuel}</td>
                  <td>{item?.fuelWastage}</td>
                  <td>{item?.fuelRecirculation}</td>
                  <td>{item?.fuelTesting}</td>
                  <td>BSD {formatToTwoDecimal(item?.rate)}</td>
                  <td>BSD {formatToTwoDecimal(item?.tax)}</td>
                  <td>BSD {formatToTwoDecimal(item?.totalFee)}</td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ViewFuelRoyaltySubmittedTable;
